(function () {
  if (window.JiadaWishlist) {
    window.JiadaWishlist.refresh(document);
    return;
  }

  const STORAGE_KEY = 'jiada_wishlist_v1';
  const MAX_ITEMS = 100;
  const observedBagIconHeaders = new WeakSet();

  function readItems() {
    try {
      const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(parsed) ? parsed.filter((item) => item && item.variantId) : [];
    } catch (error) {
      return [];
    }
  }

  function saveItems(items) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
      document.dispatchEvent(new CustomEvent('jiada:wishlist-change'));
      return true;
    } catch (error) {
      return false;
    }
  }

  function itemKey(item) {
    return `${item.productId || 'product'}:${item.variantId}`;
  }

  function normalizeItem(item) {
    return {
      key: itemKey(item),
      productId: String(item.productId || ''),
      variantId: String(item.variantId || ''),
      title: String(item.title || ''),
      variantTitle: String(item.variantTitle || ''),
      url: String(item.url || ''),
      image: String(item.image || ''),
      price: String(item.price || ''),
      isEvent: item.isEvent === true || item.isEvent === 'true',
      savedAt: Date.now(),
    };
  }

  function isSaved(item) {
    const key = itemKey(item);
    return readItems().some((savedItem) => savedItem.key === key || itemKey(savedItem) === key);
  }

  function toggleItem(item) {
    const normalized = normalizeItem(item);
    let items = readItems();
    const index = items.findIndex((savedItem) => itemKey(savedItem) === normalized.key);

    if (index >= 0) {
      items.splice(index, 1);
    } else {
      items.unshift(normalized);
    }

    saveItems(items);
  }

  function removeItem(key) {
    saveItems(readItems().filter((item) => itemKey(item) !== key));
  }

  function itemFromDataButton(button) {
    return normalizeItem({
      productId: button.dataset.productId,
      variantId: button.dataset.variantId,
      title: button.dataset.title,
      variantTitle: button.dataset.variantTitle,
      url: button.dataset.url,
      image: button.dataset.image,
      price: button.dataset.price,
      isEvent: button.dataset.isEvent,
    });
  }

  function itemFromProductButton(button) {
    const form = document.getElementById(button.dataset.productForm);
    const variantInput = form && form.querySelector('[name="id"]');
    const variantId = variantInput ? String(variantInput.value) : String(button.dataset.variantId || '');
    const json = document.getElementById(button.dataset.variantsJson);
    let variants = [];

    try {
      variants = json ? JSON.parse(json.textContent) : [];
    } catch (error) {
      variants = [];
    }

    const variant = variants.find((entry) => String(entry.id) === variantId) || variants[0] || {};

    return normalizeItem({
      productId: button.dataset.productId,
      variantId: variant.id || variantId,
      title: button.dataset.title,
      variantTitle: variant.title || '',
      url: variant.url || button.dataset.url,
      image: variant.image || button.dataset.image,
      price: variant.price || button.dataset.price,
      isEvent: button.dataset.isEvent,
    });
  }

  function getButtonItem(button) {
    return button.hasAttribute('data-jiada-product-wishlist')
      ? itemFromProductButton(button)
      : itemFromDataButton(button);
  }

  function productHandleFromUrl(value) {
    try {
      const url = new URL(value, window.location.origin);
      const match = url.pathname.match(/\/products\/([^/]+)/i);
      return match ? decodeURIComponent(match[1]).toLowerCase() : '';
    } catch (error) {
      return '';
    }
  }

  function savedItemForProductUrl(value) {
    const handle = productHandleFromUrl(value);
    if (!handle) return null;
    return readItems().find((item) => productHandleFromUrl(item.url) === handle) || null;
  }

  function updateCardWishlistButtons(root = document) {
    root.querySelectorAll('[data-jiada-card-wishlist]').forEach((button) => {
      const saved = Boolean(savedItemForProductUrl(button.dataset.productUrl));
      const title = button.dataset.title || 'product';
      button.setAttribute('aria-pressed', String(saved));
      button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${title} ${saved ? 'from' : 'to'} wishlist`);
      button.title = saved ? 'Remove from wishlist' : 'Save to wishlist';
      setHeartIcon(button, saved);
    });
  }

  function ensureProductCardWishlistButtons(root = document) {
    root.querySelectorAll('[data-jiada-card-wishlist]').forEach((button) => button.remove());
    root.querySelectorAll('.jiada-card-media-with-wishlist').forEach((media) => {
      media.classList.remove('jiada-card-media-with-wishlist');
    });
  }

  function cardPriceText(button) {
    const card = button.closest('.product-card-wrapper, .card-wrapper');
    const price = card?.querySelector(
      '.price-item--sale, .price__sale .price-item--regular, .price__regular .price-item--regular, .price-item'
    );
    return price?.textContent.trim().replace(/\s+/g, ' ') || '';
  }

  function imageUrl(value) {
    const source = typeof value === 'string' ? value : value?.src;
    if (!source) return '';
    return source.startsWith('//') ? `${window.location.protocol}${source}` : source;
  }

  async function toggleProductCardWishlist(button) {
    const savedItem = savedItemForProductUrl(button.dataset.productUrl);
    if (savedItem) {
      removeItem(itemKey(savedItem));
      animateHeart(button);
      return;
    }

    button.disabled = true;
    button.classList.add('is-loading');

    try {
      const endpoint = new URL(button.dataset.productUrl, window.location.origin);
      endpoint.search = '';
      endpoint.hash = '';
      endpoint.pathname = `${endpoint.pathname.replace(/\/$/, '')}.js`;

      const response = await fetch(endpoint.toString(), { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('Product details could not be loaded.');

      const product = await response.json();
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const variant = variants.find((entry) => entry.available !== false) || variants[0];
      if (!variant?.id) throw new Error('No product variant is available.');

      const tags = Array.isArray(product.tags) ? product.tags : String(product.tags || '').split(',');
      const productUrl = new URL(button.dataset.productUrl, window.location.origin);
      productUrl.searchParams.set('variant', variant.id);

      toggleItem({
        productId: product.id,
        variantId: variant.id,
        title: product.title || button.dataset.title,
        variantTitle: variant.title || '',
        url: productUrl.toString(),
        image: imageUrl(variant.featured_image || product.featured_image || product.images?.[0]),
        price: cardPriceText(button),
        isEvent: tags.some((tag) => String(tag).trim().toLowerCase() === 'event'),
      });
      animateHeart(button);
    } catch (error) {
      button.title = error.message || 'This product could not be saved.';
    } finally {
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }

  function updateButtons(root = document) {
    root.querySelectorAll('[data-jiada-wishlist-item], [data-jiada-product-wishlist]').forEach((button) => {
      const item = getButtonItem(button);
      const saved = item.variantId ? isSaved(item) : false;
      button.setAttribute('aria-pressed', String(saved));
      button.title = saved ? 'Remove from wishlist' : 'Save to wishlist';
      setHeartIcon(button, saved);

      const label = button.querySelector('[data-jiada-wishlist-label]');
      if (label) label.textContent = saved ? 'Saved to wishlist' : 'Save to wishlist';

      if (button.hasAttribute('data-jiada-wishlist-item')) {
        button.setAttribute('aria-label', `${saved ? 'Remove' : 'Save'} ${item.title} ${saved ? 'from' : 'to'} wishlist`);
      }
    });

    updateCardWishlistButtons(root);
  }

  function updateCounts(root = document) {
    const count = readItems().length;
    root.querySelectorAll('[data-jiada-wishlist-count]').forEach((element) => {
      element.textContent = '';
      element.hidden = count === 0;
      element.classList.remove('is-wide');
      element.setAttribute('aria-label', `${count} ${count === 1 ? 'item' : 'items'} in wishlist`);
    });

    root.querySelectorAll('[data-jiada-open-wishlist]').forEach((button) => {
      button.setAttribute('aria-pressed', String(count > 0));
      button.setAttribute('aria-label', count > 0 ? `Open wishlist, ${count} ${count === 1 ? 'item' : 'items'}` : 'Open wishlist');
      setHeartIcon(button, count > 0);
    });

    root.querySelectorAll('[data-jiada-drawer-tab="wishlist"]').forEach((button) => {
      button.classList.toggle('has-items', count > 0);
      setHeartIcon(button, count > 0);
    });
  }

  function heartSvgMarkup(filled) {
    if (filled) {
      return '<svg class="jiada-heart-icon is-filled" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21.35 10.55 20.03C5.4 15.36 2 12.27 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.77-3.4 6.86-8.55 11.54L12 21.35Z" fill="currentColor" stroke="none"/></svg>';
    }

    return '<svg class="jiada-heart-icon" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" stroke="currentColor" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function setHeartIcon(button, filled) {
    const wrapper = button?.querySelector('.svg-wrapper');
    if (wrapper) wrapper.innerHTML = heartSvgMarkup(filled);
  }

  function heartMarkup() {
    return `<span class="svg-wrapper" aria-hidden="true">${heartSvgMarkup(true)}</span>`;
  }

  function outlineHeartMarkup() {
    return `<span class="svg-wrapper" aria-hidden="true">${heartSvgMarkup(false)}</span>`;
  }

  function searchMarkup() {
    return '<span class="svg-wrapper" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8" stroke="currentColor" stroke-width="1.15"/><path d="m21 21-4.35-4.35" stroke="currentColor" stroke-width="1.15" stroke-linecap="round"/></svg></span>';
  }

  function accountSvgMarkup() {
    return '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" aria-hidden="true"><circle cx="12" cy="12" r="9.25" stroke="currentColor" stroke-width="1.15"/><circle cx="12" cy="9" r="3.25" stroke="currentColor" stroke-width="1.15"/><path d="M6.5 19a6.4 6.4 0 0 1 11 0" stroke="currentColor" stroke-width="1.15" stroke-linecap="round"/></svg>';
  }

  function bagSvgMarkup() {
    return '<svg xmlns="http://www.w3.org/2000/svg" class="jiada-header-bag-icon" fill="none" viewBox="0 0 24 24" aria-hidden="true"><path d="M5 8.25h14l1 11.5H4l1-11.5Z" stroke="currentColor" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.5 8.25V6.5a3.5 3.5 0 0 1 7 0v1.75" stroke="currentColor" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  }

  function closeMarkup() {
    return '<span class="svg-wrapper" aria-hidden="true"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path d="M5 5l14 14M19 5 5 19" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg></span>';
  }

  function wishlistCountMarkup() {
    return '<span class="jiada-wishlist-count" data-jiada-wishlist-count hidden>0</span>';
  }

  function syncHeaderBagIcon() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    const target = cartLink
      ? Array.from(cartLink.children).find((element) => element.classList.contains('svg-wrapper'))
      : null;

    if (!target || target.querySelector('.jiada-header-bag-icon')) return;

    const template = document.createElement('template');
    template.innerHTML = bagSvgMarkup();
    const icon = template.content.firstElementChild;
    target.replaceChildren(icon);
  }

  function observeHeaderBagIcon() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    const header = cartLink?.closest('sticky-header, .header-wrapper, header') || cartLink?.parentElement;
    if (!header || observedBagIconHeaders.has(header)) return;

    observedBagIconHeaders.add(header);
    new MutationObserver(() => syncHeaderBagIcon()).observe(header, {
      childList: true,
      subtree: true,
    });
  }

  function syncHeaderUtilityIcons() {
    const searchIcon = document.querySelector('.header__icon--search svg.icon-search, .header__icon--search svg');
    const accountIcon = document.querySelector('.header__icon--account svg');

    if (searchIcon && !searchIcon.classList.contains('jiada-header-search-icon')) {
      const template = document.createElement('template');
      template.innerHTML = searchMarkup();
      const icon = template.content.querySelector('svg');
      icon.classList.add('icon', 'icon-search', 'jiada-header-search-icon');
      searchIcon.replaceWith(icon);
    }

    if (accountIcon && !accountIcon.classList.contains('jiada-header-account-icon')) {
      const template = document.createElement('template');
      template.innerHTML = accountSvgMarkup();
      const icon = template.content.querySelector('svg');
      icon.classList.add('icon', 'icon-account', 'jiada-header-account-icon');
      accountIcon.replaceWith(icon);
    }
  }

  function ensureDesktopContactLink(root = document) {
    const header = root.querySelector('.header');
    const search = header?.querySelector('.header__search');
    if (!header || !search) return;

    const menuLinks = Array.from(header.querySelectorAll('.header__inline-menu a'));
    const sourceLink = menuLinks.find((link) => link.textContent.trim().toLowerCase() === 'contact');
    if (!sourceLink) return;

    sourceLink.closest('li')?.classList.add('jiada-header-contact-source');
    if (header.querySelector('.jiada-header-contact')) return;

    const contactLink = document.createElement('a');
    contactLink.className = 'jiada-header-contact link focus-inset';
    contactLink.href = sourceLink.href;
    contactLink.textContent = sourceLink.textContent.trim();
    search.parentNode.insertBefore(contactLink, search);
  }

  function ensureHeaderControls(root = document) {
    const cartLink = root.querySelector('#cart-icon-bubble');
    if (cartLink && !document.querySelector('.jiada-header-wishlist')) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'header__icon header__icon--wishlist link focus-inset jiada-header-wishlist';
      button.dataset.jiadaOpenWishlist = '';
      button.setAttribute('aria-label', 'Open wishlist');
      button.setAttribute('aria-pressed', 'false');
      button.innerHTML = outlineHeartMarkup() + wishlistCountMarkup();
      cartLink.parentNode.insertBefore(button, cartLink);
    }

    const header = root.querySelector('.header');
    const headerDrawer = header?.querySelector('header-drawer');
    if (header && headerDrawer && !header.querySelector('.jiada-mobile-header-search')) {
      const searchButton = document.createElement('button');
      searchButton.type = 'button';
      searchButton.className = 'header__icon link focus-inset jiada-mobile-header-search';
      searchButton.dataset.jiadaOpenHeaderSearch = '';
      searchButton.setAttribute('aria-label', 'Search products and events');
      searchButton.innerHTML = searchMarkup();
      headerDrawer.insertAdjacentElement('afterend', searchButton);
    }

    const navigation = root.querySelector('.menu-drawer__navigation');
    if (navigation && !navigation.querySelector('.jiada-mobile-menu-tools')) {
      const tools = document.createElement('div');
      tools.className = 'jiada-mobile-menu-tools';

      const topbar = document.createElement('div');
      topbar.className = 'jiada-mobile-menu-topbar';

      const topbarActions = document.createElement('div');
      topbarActions.className = 'jiada-mobile-menu-topbar__actions';

      const wishlistButton = document.createElement('button');
      wishlistButton.type = 'button';
      wishlistButton.className = 'jiada-menu-wishlist';
      wishlistButton.dataset.jiadaOpenWishlist = '';
      wishlistButton.setAttribute('aria-label', 'Open wishlist');
      wishlistButton.setAttribute('aria-pressed', 'false');
      wishlistButton.innerHTML = outlineHeartMarkup() + wishlistCountMarkup();

      const closeButton = document.createElement('button');
      closeButton.type = 'button';
      closeButton.className = 'jiada-menu-close';
      closeButton.dataset.jiadaMenuClose = '';
      closeButton.setAttribute('aria-label', 'Close menu');
      closeButton.innerHTML = closeMarkup();

      topbarActions.append(wishlistButton, closeButton);
      topbar.append(topbarActions);

      const searchForm = document.createElement('form');
      searchForm.className = 'jiada-menu-search';
      searchForm.action = window.routes?.search_url || '/search';
      searchForm.method = 'get';
      searchForm.setAttribute('role', 'search');

      const searchIcon = document.createElement('span');
      searchIcon.className = 'jiada-menu-search__icon';
      searchIcon.setAttribute('aria-hidden', 'true');
      searchIcon.innerHTML = searchMarkup();

      const searchInput = document.createElement('input');
      searchInput.className = 'jiada-menu-search__input';
      searchInput.type = 'search';
      searchInput.name = 'q';
      searchInput.placeholder = 'Search products and events';
      searchInput.autocomplete = 'off';
      searchInput.dataset.jiadaMenuSearchInput = '';
      searchInput.setAttribute('aria-label', 'Search products and events');
      searchInput.setAttribute('aria-expanded', 'false');
      searchInput.setAttribute('aria-controls', 'JiadaMobileMenuSearchResults');

      const searchType = document.createElement('input');
      searchType.type = 'hidden';
      searchType.name = 'type';
      searchType.value = 'product';

      searchForm.append(searchIcon, searchInput, searchType);

      const searchResults = document.createElement('div');
      searchResults.id = 'JiadaMobileMenuSearchResults';
      searchResults.className = 'jiada-menu-search-results';
      searchResults.dataset.jiadaMenuSearchResults = '';
      searchResults.setAttribute('role', 'listbox');
      searchResults.hidden = true;

      tools.append(topbar, searchForm, searchResults);
      navigation.insertBefore(tools, navigation.firstChild);
    }
  }

  function animateHeart(button) {
    if (!button) return;
    button.classList.remove('is-animating');
    void button.offsetWidth;
    button.classList.add('is-animating');
    window.setTimeout(() => button.classList.remove('is-animating'), 320);
  }

  function openWishlist(trigger) {
    const drawer = document.querySelector('cart-drawer');
    if (!drawer) return;

    const openMenu = trigger.closest('details[open]');
    if (openMenu) {
      const summary = openMenu.querySelector('summary');
      if (summary) summary.click();
      else openMenu.removeAttribute('open');
    }

    window.setTimeout(() => {
      if (typeof drawer.open === 'function') drawer.open(trigger);
      showPanel(drawer, 'wishlist');
    }, 0);
  }

  function createWishlistCard(item) {
    const card = document.createElement('article');
    card.className = 'jiada-wishlist-card';

    const imageLink = document.createElement('a');
    imageLink.href = item.url;
    imageLink.setAttribute('aria-label', item.title);

    if (item.image) {
      const image = document.createElement('img');
      image.className = 'jiada-wishlist-card__image';
      image.src = item.image;
      image.alt = '';
      image.loading = 'lazy';
      imageLink.appendChild(image);
    } else {
      const placeholder = document.createElement('span');
      placeholder.className = 'jiada-wishlist-card__image';
      imageLink.appendChild(placeholder);
    }

    const content = document.createElement('div');
    content.className = 'jiada-wishlist-card__content';

    const title = document.createElement('a');
    title.className = 'jiada-wishlist-card__title';
    title.href = item.url;
    title.textContent = item.title;
    content.appendChild(title);

    if (item.variantTitle && item.variantTitle !== 'Default Title') {
      const variant = document.createElement('p');
      variant.className = 'jiada-wishlist-card__variant';
      variant.textContent = item.variantTitle;
      content.appendChild(variant);
    }

    const price = document.createElement('p');
    price.className = 'jiada-wishlist-card__price';
    price.textContent = item.price;
    content.appendChild(price);

    let action;
    if (item.isEvent) {
      action = document.createElement('a');
      action.href = item.url;
      action.textContent = 'Choose ticket details';
    } else {
      action = document.createElement('button');
      action.type = 'button';
      action.textContent = 'Add to bag';
      action.dataset.jiadaWishlistAdd = item.variantId;
      action.dataset.jiadaWishlistKey = itemKey(item);
    }
    action.className = 'jiada-wishlist-card__action button button--secondary';
    content.appendChild(action);

    const status = document.createElement('p');
    status.className = 'jiada-wishlist-card__status';
    status.setAttribute('role', 'status');
    status.hidden = true;
    content.appendChild(status);

    const remove = document.createElement('button');
    remove.type = 'button';
    remove.className = 'jiada-wishlist-card__remove';
    remove.dataset.jiadaWishlistRemove = itemKey(item);
    remove.setAttribute('aria-label', `Remove ${item.title} from wishlist`);
    remove.innerHTML = heartMarkup();

    card.appendChild(imageLink);
    card.appendChild(content);
    card.appendChild(remove);
    return card;
  }

  function renderWishlist(root = document) {
    const items = readItems();

    root.querySelectorAll('[data-jiada-wishlist-items]').forEach((container) => {
      container.replaceChildren(...items.map(createWishlistCard));
    });

    root.querySelectorAll('[data-jiada-wishlist-empty]').forEach((emptyState) => {
      emptyState.hidden = items.length > 0;
    });
  }

  function showPanel(drawer, panelName) {
    if (!drawer) return;

    drawer.querySelectorAll('[data-jiada-drawer-panel]').forEach((panel) => {
      panel.hidden = panel.dataset.jiadaDrawerPanel !== panelName;
    });

    drawer.querySelectorAll('[data-jiada-drawer-tab]').forEach((tab) => {
      const selected = tab.dataset.jiadaDrawerTab === panelName;
      tab.classList.toggle('is-active', selected);
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });

    if (panelName === 'wishlist') renderWishlist(drawer);
  }

  async function addWishlistItem(button) {
    const drawer = button.closest('cart-drawer') || document.querySelector('cart-drawer');
    const card = button.closest('.jiada-wishlist-card');
    const status = card && card.querySelector('.jiada-wishlist-card__status');
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    try {
      const body = {
        items: [{ id: Number(button.dataset.jiadaWishlistAdd), quantity: 1 }],
      };

      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        body.sections = drawer.getSectionsToRender().map((section) => section.id).join(',');
        body.sections_url = window.location.pathname;
      }

      const response = await fetch(`${window.routes?.cart_add_url || '/cart/add'}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify(body),
      });
      const result = await response.json();

      if (!response.ok) throw new Error(result.description || 'This product could not be added.');

      if (drawer && typeof drawer.renderContents === 'function' && result.sections) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(result);
      } else {
        window.location.href = window.routes?.cart_url || '/cart';
      }
    } catch (error) {
      if (status) {
        status.textContent = error.message || 'This product could not be added.';
        status.hidden = false;
      }
      button.disabled = false;
      button.textContent = originalText;
    }
  }

  function closeShareMenus(exceptMenu) {
    document.querySelectorAll('.jiada-share-menu').forEach((menu) => {
      if (menu === exceptMenu) return;
      const trigger = menu.jiadaTrigger;
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      menu.remove();
    });
    if (!document.querySelector('.jiada-share-menu')) document.body.classList.remove('jiada-share-open');
  }

  function shareIconMarkup(icon) {
    const icons = {
      link: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M10.6 13.4a4.5 4.5 0 0 0 6.4 0l2.1-2.1a4.5 4.5 0 0 0-6.4-6.4l-1.2 1.2M13.4 10.6a4.5 4.5 0 0 0-6.4 0l-2.1 2.1a4.5 4.5 0 0 0 6.4 6.4l1.2-1.2"/></svg>',
      whatsapp: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M20 11.7a8 8 0 0 1-11.8 7l-4.2 1.3 1.4-4a8 8 0 1 1 14.6-4.3Z"/><path d="M9.1 8.2c.3-.4.7-.3.9.1l.8 1.8c.1.3 0 .5-.2.7l-.6.6c.8 1.5 1.9 2.5 3.4 3.2l.6-.8c.2-.2.4-.3.7-.2l1.8.9c.3.2.4.5.2.8-.5 1-1.4 1.4-2.5 1.3-3.6-.5-6.7-3.5-7-7.1 0-.6.7-1.3 1.9-1.3Z"/></svg>',
      email: '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="3" y="5" width="18" height="14" rx="1.5"/><path d="m4 7 8 6 8-6"/></svg>',
      close: '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 5l14 14M19 5 5 19"/></svg>',
    };
    return icons[icon] || '';
  }

  function setShareItemContent(item, label, iconMarkup) {
    const icon = document.createElement('span');
    icon.className = 'jiada-share-menu__icon';
    icon.innerHTML = iconMarkup;

    const text = document.createElement('span');
    text.className = 'jiada-share-menu__label';
    text.textContent = label;
    item.append(icon, text);
  }

  function shareMenuItem(label, href, iconMarkup) {
    const link = document.createElement('a');
    link.className = 'jiada-share-menu__item';
    link.href = href;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.dataset.jiadaShareLink = '';
    setShareItemContent(link, label, iconMarkup);
    return link;
  }

  function shareProduct(button) {
    const currentMenu = document.querySelector('.jiada-share-menu');
    if (currentMenu && currentMenu.jiadaTrigger === button) {
      closeShareMenus();
      return;
    }

    closeShareMenus();
    const title = button.dataset.shareTitle || document.title;
    const url = button.dataset.shareUrl || window.location.href;
    const message = `${title} ${url}`;
    const menu = document.createElement('div');
    menu.className = 'jiada-share-menu';
    menu.setAttribute('role', 'dialog');
    menu.setAttribute('aria-modal', 'true');
    menu.setAttribute('aria-labelledby', 'JiadaShareTitle');
    menu.jiadaTrigger = button;

    const backdrop = document.createElement('button');
    backdrop.type = 'button';
    backdrop.className = 'jiada-share-menu__backdrop';
    backdrop.dataset.jiadaShareClose = '';
    backdrop.setAttribute('aria-label', 'Close sharing options');

    const dialog = document.createElement('div');
    dialog.className = 'jiada-share-menu__dialog';

    const header = document.createElement('div');
    header.className = 'jiada-share-menu__header';

    const heading = document.createElement('h2');
    heading.id = 'JiadaShareTitle';
    heading.className = 'jiada-share-menu__title';
    heading.textContent = 'Share with friends';

    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.className = 'jiada-share-menu__close';
    closeButton.dataset.jiadaShareClose = '';
    closeButton.setAttribute('aria-label', 'Close sharing options');
    closeButton.innerHTML = shareIconMarkup('close');

    const items = document.createElement('div');
    items.className = 'jiada-share-menu__items';

    const copyButton = document.createElement('button');
    copyButton.type = 'button';
    copyButton.className = 'jiada-share-menu__item';
    copyButton.dataset.jiadaCopyShare = url;
    setShareItemContent(copyButton, 'Copy link', shareIconMarkup('link'));

    const facebookIcon = '<span class="jiada-share-brand jiada-share-brand--facebook" aria-hidden="true">f</span>';
    const linkedInIcon = '<span class="jiada-share-brand" aria-hidden="true">in</span>';
    const xIcon = '<span class="jiada-share-brand jiada-share-brand--x" aria-hidden="true">X</span>';

    items.append(
      copyButton,
      shareMenuItem('WhatsApp', `https://wa.me/?text=${encodeURIComponent(message)}`, shareIconMarkup('whatsapp')),
      shareMenuItem(
        'Facebook',
        `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
        facebookIcon
      ),
      shareMenuItem(
        'LinkedIn',
        `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
        linkedInIcon
      ),
      shareMenuItem(
        'X',
        `https://twitter.com/intent/tweet?text=${encodeURIComponent(title)}&url=${encodeURIComponent(url)}`,
        xIcon
      ),
      shareMenuItem(
        'Email',
        `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(message)}`,
        shareIconMarkup('email')
      )
    );

    header.append(heading, closeButton);
    dialog.append(header, items);
    menu.append(backdrop, dialog);
    document.body.appendChild(menu);
    document.body.classList.add('jiada-share-open');
    button.setAttribute('aria-expanded', 'true');
    closeButton.focus();
  }

  async function copyShareLink(button) {
    const url = button.dataset.jiadaCopyShare;
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(url);
      } else {
        const textarea = document.createElement('textarea');
        textarea.value = url;
        textarea.setAttribute('readonly', '');
        textarea.style.position = 'fixed';
        textarea.style.opacity = '0';
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        textarea.remove();
      }
      const label = button.querySelector('.jiada-share-menu__label');
      if (label) label.textContent = 'Copied';
      window.setTimeout(() => closeShareMenus(), 900);
    } catch (error) {
      const label = button.querySelector('.jiada-share-menu__label');
      if (label) label.textContent = 'Copy failed';
    }
  }

  async function nativeShare(button) {
    try {
      await navigator.share({
        title: button.dataset.shareTitle || document.title,
        url: button.dataset.shareUrl || window.location.href,
      });
      closeShareMenus();
    } catch (error) {
      if (!error || error.name !== 'AbortError') button.textContent = 'Sharing unavailable';
    }
  }

  let menuSearchTimer;
  let menuSearchIndex;

  function normalizedSearchText(value) {
    return String(value || '')
      .toLocaleLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function readMenuSearchIndex() {
    if (menuSearchIndex) return menuSearchIndex;

    try {
      const index = document.getElementById('JiadaMenuSearchIndex');
      const parsed = JSON.parse(index?.textContent || '[]');
      menuSearchIndex = Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      menuSearchIndex = [];
    }

    return menuSearchIndex;
  }

  function findLocalMenuResults(query) {
    const terms = normalizedSearchText(query).split(/\s+/).filter(Boolean);
    if (!terms.length) return [];

    return readMenuSearchIndex()
      .filter((item) => {
        const searchable = normalizedSearchText(item.searchText);
        return terms.every((term) => searchable.includes(term));
      })
      .slice(0, 6);
  }

  async function fetchPredictiveMenuResults(query) {
    const baseUrl = window.routes?.predictive_search_url || '/search/suggest';
    const endpoint = baseUrl.endsWith('.json') ? baseUrl : `${baseUrl}.json`;
    const params = new URLSearchParams({
      q: query,
      'resources[type]': 'product',
      'resources[limit]': '6',
      'resources[options][unavailable_products]': 'last',
      'resources[options][fields]': 'title,product_type,variants.title,body,tag',
    });

    try {
      const response = await fetch(`${endpoint}?${params.toString()}`, {
        headers: { Accept: 'application/json' },
      });
      if (!response.ok) return [];

      const data = await response.json();
      return (data.resources?.results?.products || []).map((product) => ({
        title: product.title || '',
        url: product.url || '',
        image:
          typeof product.image === 'string'
            ? product.image
            : product.image?.url || product.featured_image?.url || product.featured_image || '',
        price: product.price || '',
        meta: product.type || product.product_type || '',
        searchText: '',
      }));
    } catch (error) {
      return [];
    }
  }

  function mergeMenuResults(primary, secondary) {
    const seen = new Set();

    return [...primary, ...secondary]
      .filter((item) => {
        const key = String(item.url || item.title || '').split('?')[0].toLocaleLowerCase();
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      })
      .slice(0, 6);
  }

  function renderMenuSearchResults(container, items, query) {
    if (!container) return;
    container.replaceChildren();

    if (!query) {
      container.hidden = true;
      return;
    }

    if (!items.length) {
      const empty = document.createElement('p');
      empty.className = 'jiada-menu-search-empty';
      empty.textContent = 'No matching products or events found.';
      container.appendChild(empty);
    } else {
      items.forEach((item) => {
        const result = document.createElement('a');
        result.className = 'jiada-menu-search-result';
        result.href = item.url;
        result.setAttribute('role', 'option');

        if (item.image) {
          const image = document.createElement('img');
          image.className = 'jiada-menu-search-result__image';
          image.src = item.image;
          image.alt = '';
          image.loading = 'lazy';
          result.appendChild(image);
        } else {
          const placeholder = document.createElement('span');
          placeholder.className = 'jiada-menu-search-result__image jiada-menu-search-result__image--empty';
          result.appendChild(placeholder);
        }

        const content = document.createElement('span');
        content.className = 'jiada-menu-search-result__content';

        const title = document.createElement('span');
        title.className = 'jiada-menu-search-result__title';
        title.textContent = item.title;
        content.appendChild(title);

        if (item.meta) {
          const meta = document.createElement('span');
          meta.className = 'jiada-menu-search-result__meta';
          meta.textContent = item.meta;
          content.appendChild(meta);
        }

        result.appendChild(content);

        container.appendChild(result);
      });
    }

    const allResults = document.createElement('a');
    allResults.className = 'jiada-menu-search-all';
    allResults.href = `${window.routes?.search_url || '/search'}?q=${encodeURIComponent(query)}&type=product`;
    allResults.textContent = 'View all search results';
    container.appendChild(allResults);
    container.hidden = false;
  }

  function closeMenuSearchResults(exceptTools) {
    document.querySelectorAll('[data-jiada-menu-search-results]').forEach((container) => {
      if (exceptTools && container.closest('.jiada-mobile-menu-tools') === exceptTools) return;
      container.hidden = true;
    });
  }

  function ensureHeaderSearchResults(root = document) {
    const inputs = root.querySelectorAll(
      '.search-modal input[type="search"][name="q"], .header__search input[type="search"][name="q"]'
    );

    inputs.forEach((input, index) => {
      if (input.hasAttribute('data-jiada-header-search-input')) return;
      const form = input.closest('form');
      if (!form) return;

      const results = document.createElement('div');
      const resultId = `JiadaHeaderSearchResults-${Date.now()}-${index}`;
      results.id = resultId;
      results.className = 'jiada-header-search-results';
      results.dataset.jiadaHeaderSearchResults = '';
      results.setAttribute('role', 'listbox');
      results.setAttribute('aria-label', 'Suggested products and events');
      results.hidden = true;

      input.dataset.jiadaHeaderSearchInput = '';
      input.setAttribute('autocomplete', 'off');
      input.setAttribute('placeholder', 'Search products and events');
      input.setAttribute('aria-autocomplete', 'list');
      input.setAttribute('aria-controls', resultId);
      input.setAttribute('aria-expanded', 'false');
      form.classList.add('jiada-header-search-form');
      form.appendChild(results);
    });
  }

  function closeHeaderSearchResults(exceptForm) {
    document.querySelectorAll('[data-jiada-header-search-results]').forEach((container) => {
      const form = container.closest('.jiada-header-search-form');
      if (exceptForm && form === exceptForm) return;
      container.hidden = true;
      form?.querySelector('[data-jiada-header-search-input]')?.setAttribute('aria-expanded', 'false');
    });
  }

  function searchResultsForInput(input) {
    if (input.hasAttribute('data-jiada-header-search-input')) {
      return input.closest('.jiada-header-search-form')?.querySelector('[data-jiada-header-search-results]');
    }

    return input
      .closest('.jiada-mobile-menu-tools')
      ?.querySelector('[data-jiada-menu-search-results]');
  }

  function queueSearchSuggestions(input) {
    window.clearTimeout(menuSearchTimer);
    const query = input.value.trim();
    const results = searchResultsForInput(input);
    const localResults = findLocalMenuResults(query);
    renderMenuSearchResults(results, localResults, query);
    input.setAttribute('aria-expanded', String(Boolean(query)));

    if (!query) return;

    menuSearchTimer = window.setTimeout(async () => {
      const predictiveResults = await fetchPredictiveMenuResults(query);
      if (input.value.trim() !== query) return;
      renderMenuSearchResults(results, mergeMenuResults(localResults, predictiveResults), query);
      input.setAttribute('aria-expanded', 'true');
    }, 220);
  }

  function refresh(root = document) {
    ensureHeaderControls(document);
    ensureDesktopContactLink(document);
    ensureHeaderSearchResults(document);
    syncHeaderBagIcon();
    observeHeaderBagIcon();
    syncHeaderUtilityIcons();
    ensureProductCardWishlistButtons(root);
    updateButtons(root);
    updateCounts(document);
    renderWishlist(root);
  }

  document.addEventListener('click', (event) => {
    const shareClose = event.target.closest('[data-jiada-share-close]');
    if (shareClose) {
      event.preventDefault();
      closeShareMenus();
      return;
    }

    if (!event.target.closest('.jiada-share-menu, [data-jiada-share]')) closeShareMenus();
    if (!event.target.closest('.jiada-mobile-menu-tools')) closeMenuSearchResults();
    if (!event.target.closest('.jiada-header-search-form')) closeHeaderSearchResults();

    const menuClose = event.target.closest('[data-jiada-menu-close]');
    if (menuClose) {
      event.preventDefault();
      closeMenuSearchResults();
      const openMenu = menuClose.closest('details[open]');
      const summary = openMenu?.querySelector(':scope > summary');
      if (summary) summary.click();
      else openMenu?.removeAttribute('open');
      return;
    }

    const menuToggle = event.target.closest('summary.header__icon--menu');
    if (menuToggle) {
      window.setTimeout(() => refresh(document), 0);
    }

    const openHeaderSearch = event.target.closest('[data-jiada-open-header-search]');
    if (openHeaderSearch) {
      event.preventDefault();
      const searchToggle = document.querySelector('.header__search summary.header__icon--search');
      if (searchToggle) {
        searchToggle.click();
        if (window.matchMedia('(max-width: 989px)').matches) {
          window.setTimeout(() => document.body.classList.remove('overflow-hidden-mobile'), 0);
        }
      }
      return;
    }

    const copyShareButton = event.target.closest('[data-jiada-copy-share]');
    if (copyShareButton) {
      event.preventDefault();
      copyShareLink(copyShareButton);
      return;
    }

    const nativeShareButton = event.target.closest('[data-jiada-native-share]');
    if (nativeShareButton) {
      event.preventDefault();
      nativeShare(nativeShareButton);
      return;
    }

    const shareLink = event.target.closest('[data-jiada-share-link]');
    if (shareLink) {
      window.setTimeout(() => closeShareMenus(), 0);
      return;
    }

    const shareButton = event.target.closest('[data-jiada-share]');
    if (shareButton) {
      event.preventDefault();
      shareProduct(shareButton);
      return;
    }

    const cardWishlistButton = event.target.closest('[data-jiada-card-wishlist]');
    if (cardWishlistButton) {
      event.preventDefault();
      event.stopPropagation();
      toggleProductCardWishlist(cardWishlistButton);
      return;
    }

    const wishlistButton = event.target.closest('[data-jiada-wishlist-item], [data-jiada-product-wishlist]');
    if (wishlistButton) {
      event.preventDefault();
      const item = getButtonItem(wishlistButton);
      if (!item.variantId) return;
      toggleItem(item);
      animateHeart(wishlistButton);
      return;
    }

    const openWishlistButton = event.target.closest('[data-jiada-open-wishlist]');
    if (openWishlistButton) {
      event.preventDefault();
      animateHeart(openWishlistButton);
      openWishlist(openWishlistButton);
      return;
    }

    const tab = event.target.closest('[data-jiada-drawer-tab]');
    if (tab) {
      showPanel(tab.closest('cart-drawer'), tab.dataset.jiadaDrawerTab);
      return;
    }

    const showBag = event.target.closest('[data-jiada-show-bag]');
    if (showBag) {
      showPanel(showBag.closest('cart-drawer'), 'bag');
      return;
    }

    const remove = event.target.closest('[data-jiada-wishlist-remove]');
    if (remove) {
      removeItem(remove.dataset.jiadaWishlistRemove);
      return;
    }

    const add = event.target.closest('[data-jiada-wishlist-add]');
    if (add) addWishlistItem(add);
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('input[name="id"], select[name="id"]')) updateButtons(document);
  });

  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-jiada-menu-search-input], [data-jiada-header-search-input]');
    if (!input) return;
    queueSearchSuggestions(input);
  });

  document.addEventListener('focusin', (event) => {
    const input = event.target.closest('[data-jiada-header-search-input]');
    if (input?.value.trim()) queueSearchSuggestions(input);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    closeShareMenus();
    closeHeaderSearchResults();
    closeMenuSearchResults();
  });

  document.addEventListener('jiada:wishlist-change', () => refresh(document));
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => refresh(document));
  } else {
    refresh(document);
  }
  document.addEventListener('shopify:section:load', () => refresh(document));
  window.addEventListener('storage', (event) => {
    if (event.key === STORAGE_KEY) refresh(document);
  });

  window.JiadaWishlist = {
    refresh,
    showPanel,
    readItems,
  };
})();
